import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { ModalContainerComponent } from '../../_common/modal-container/modal-container.component'
import { CoreService, HsApiService, NotificationService } from '../../../services'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'modal-address-create',
  templateUrl: './modal-address-create.component.html',
})
export class ModalAddressCreateComponent {
  @ViewChild('modal') childModal: ModalContainerComponent
  @Output() onCreate: EventEmitter<any> = new EventEmitter()
  addressName: string
  street: string
  streetNumber: string
  city: string
  zip: string
  phone: string
  isValid: boolean = false
  loading = false
  customerCode: string

  constructor(
    private core: CoreService,
    private hsApi: HsApiService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {
    this.customerCode = this.core.services.user.user?.company?.externalId
  }

  checkValid() {
    this.isValid = true
    if (!this.addressName?.length) {
      this.isValid = false
    }
    if (!this.street?.length) {
      this.isValid = false
    }
    if (!this.streetNumber?.length) {
      this.isValid = false
    }
    if (!this.city?.length) {
      this.isValid = false
    }
    if (!this.zip?.length) {
      this.isValid = false
    }
    if (!this.phone?.length) {
      this.isValid = false
    }
    if (!this.isValid) {
      this.notificationService.warning(this.translateService.instant('modalAddressCreate.invalidForm'))
    }
    return this.isValid
  }

  async createAddress() {
    if (!this.checkValid()) {
      return
    }
    this.loading = true
    const res = await this.hsApi.createHsAddress({
      name: this.addressName,
      customerCode: this.customerCode,
      street: this.street,
      houseNumber: this.streetNumber,
      city: this.city,
      zip: this.zip,
      phone: this.phone,
      country: 'CZ',
    })
    this.loading = false
    this.onCreate.emit(res)
    this.hideChildModal()
  }

  public async showChildModal() {
    this.childModal.showChildModal()
  }

  public hideChildModal(): void {
    this.childModal.hideChildModal()
  }
}
